import React from "react";
import { Menu, ListItemIcon, MenuItem } from "@mui/material";
import { useNavigate } from "react-router";
import {
  Edit,
  Settings,
  PlayArrow,
  DownloadDoneOutlined,
  HighlightOff,
  BarChart,
  Delete,
} from "@mui/icons-material";
import { usePostContext } from "../../contexts/postContext";

export default function PostItemActions(props) {
  const navigate = useNavigate();
  const {
    activeGridItemActions,
    setActiveGridItemActions,
    setActiveGridItem,
    setShowPublish,
    setShowUnpublish,
    editRoute,
    previewRoute,
    triggerPostDeleteFunction,
    activeGridItem,
    setShowPostSettings,
  } = usePostContext();


  return (
    <>
      <Menu
        id={`video-actions-menu-${activeGridItemActions.id}`}
        open={Boolean(activeGridItemActions.anchorElement)}
        anchorEl={activeGridItemActions.anchorElement}
        onClose={() => {
          setActiveGridItemActions({ anchorElement: null, id: null });
          setActiveGridItem(null);
        }}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "left",
        }}
      >
        <MenuItem
          onClick={() => {
            navigate(`${editRoute}/${activeGridItemActions.id}`);
          }}
        >
          <ListItemIcon>
            <Edit fontSize="small" />
          </ListItemIcon>
          Edit
        </MenuItem>

        <MenuItem onClick={() => setShowPostSettings(true)}>
          <ListItemIcon>
            <Settings fontSize="small" />
          </ListItemIcon>
          Settings
        </MenuItem>

        <MenuItem
          onClick={() => {
            window.open(`${previewRoute}/${activeGridItemActions.id}`);
          }}
        >
          <ListItemIcon>
            <PlayArrow fontSize="small" />
          </ListItemIcon>
          Preview
        </MenuItem>
        <MenuItem
          onClick={() => {
            setShowPublish(true);
          }}
        >
          <ListItemIcon>
            <DownloadDoneOutlined fontSize="small" />
          </ListItemIcon>
          {activeGridItem?.status === "published" ? "Re-publish" : "Publish"}
        </MenuItem>

        {activeGridItem &&
          (activeGridItem?.status === "modified" ||
            activeGridItem?.status === "published") && (
            <MenuItem
              onClick={() => {
                setShowUnpublish(true);
              }}
            >
              <ListItemIcon>
                <HighlightOff fontSize="small" />
              </ListItemIcon>
              Unpublish
            </MenuItem>
          )}

        <MenuItem>
          <ListItemIcon>
            <BarChart fontSize="small" />
          </ListItemIcon>
          Analytics
        </MenuItem>

        <MenuItem
          onClick={() => {
            triggerPostDeleteFunction(activeGridItemActions.id);
          }}
        >
          <ListItemIcon>
            <Delete fontSize="small" />
          </ListItemIcon>
          Delete
        </MenuItem>
      </Menu>
    </>
  );
}
